export const sortArray = (arr: string[]): string[] => {
    return arr.sort((a, b) =>
        a.localeCompare(b, "en", { sensitivity: "base" }),
    );
};
